/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FeedbackQuestion {
  answerCount?: number;
  cssClass?: string;
  cssStyle?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  formId?: number;
  group?: boolean;
  groupId?: number;
  hint?: string;
  horizontalOptions?: boolean;
  isShuffled?: boolean;
  lastQuestion?: boolean;
  maxAnswers?: number;
  maxCount?: number;
  mediaUrl?: string;
  minAnswers?: number;
  minCount?: number;
  onBlur?: string;
  onChange?: string;
  onClick?: string;
  onFocus?: string;
  questionId?: number;
  questionOrder?: number;
  questionType?: number;
  regex?: string;
  showRadioButton?: boolean;
  status?: number;
  summary?: string;
  title?: string;
  typeId?: number;
}
